import { Store } from "vuex";
import { SpaceUserInterface } from "@/resources/interfaces/spaceUserInterfaces";
import { GREEN, RED } from "@/resources/constants/busyReasons";
import { MEETING_TYPE } from "@/resources/constants/meeting";
import { i18n } from "@/resources/locales";
import VueRouter from "vue-router";
import { CHAT_TYPE } from "@/resources/constants/chat";

export default class UserSocketHandler {
  /**
   * USER_CONNECTED
   * */
  static async userConnected(store?: Store<any>, data?: any): Promise<void> {
    const { userList, userDraw } = data;
    const user = store.getters["UserStore/getSpaceUser"];

    //TODO UPDATE USERS ONLINE
    //let space = store.getters["SpaceStore/getSpace"];
    //space.usersConnected = (space.usersConnected + 1);
    //space.superSpace.usersConnected = (space.superSpace.usersConnected + 1);
    //store?.dispatch("SpaceStore/setSpaceAction", space);
    //////////////////////////

    //TODO UPDATE USERS ONLINE
    let space = store.getters["SpaceStore/getSpace"];
    let connectedUsersCounter = store.getters["SpaceStore/getConnectedUsersCounter"];
    let connectedSuperSpaceIds = store.getters["SpaceStore/getConnectedSuperSpaceIds"];

    if (connectedUsersCounter <= 0 && space && space.superSpace && space.superSpace.usersConnected) {
      connectedUsersCounter = space.superSpace.usersConnected;
      store.dispatch("SpaceStore/setConnectedUsersCounterAction", space.superSpace.usersConnected);
    }

    if (!connectedSuperSpaceIds.includes(userList.id)) {
      connectedSuperSpaceIds.push(userList.id);
      store.dispatch("SpaceStore/setConnectedSuperSpaceIdsAction", connectedSuperSpaceIds);
      connectedUsersCounter = (connectedUsersCounter + 1);
      store.dispatch("SpaceStore/setConnectedUsersCounterAction", connectedUsersCounter);
    }
    //////////////////////////

    if (user.superSpaceUser.id === userList.id) {
      await store.dispatch("UserStore/setSpaceUserLocal", userDraw);
      store.dispatch("UserStore/setIsOnlineAction", true);
    }
    await store.dispatch("SpaceStore/setUserOnlineAction", userList);
    if (userDraw) {
      await store.dispatch("SpaceStore/addUsersInDrawAction", userDraw);
      await store.dispatch("GraphicClientStore/connectedUser", userDraw);
    }
  }
  /**
   * USER_DISCONNECTED
   * */
  static async userDisconnected(store?: Store<any>, data?, connectGenetalChat?: boolean): Promise<void> {
    const { userList, userDraw } = data;
    const user = store.getters["UserStore/getSpaceUser"];

    //TODO UPDATE USERS ONLINE
    //let space = store.getters["SpaceStore/getSpace"];
    //space.usersConnected = space.usersConnected > 0 ? (space.usersConnected - 1) : space.usersConnected;
    //space.superSpace.usersConnected = space.superSpace.usersConnected > 0 ? (space.superSpace.usersConnected - 1) : space.superSpace.usersConnected;
    //store?.dispatch("SpaceStore/setSpaceAction", space);
    //////////////////////////

    //TODO UPDATE USERS ONLINE
    let connectedUsersCounter = store.getters["SpaceStore/getConnectedUsersCounter"];
    let connectedSuperSpaceIds = store.getters["SpaceStore/getConnectedSuperSpaceIds"];
    if (connectedSuperSpaceIds.includes(userList.id)) {
      connectedSuperSpaceIds = connectedSuperSpaceIds.filter(userId => userId !== userList.id);
      store.dispatch("SpaceStore/setConnectedSuperSpaceIdsAction", connectedSuperSpaceIds);
    }
    connectedUsersCounter = connectedUsersCounter > 0 ? (connectedUsersCounter - 1) : connectedUsersCounter;
    store.dispatch("SpaceStore/setConnectedUsersCounterAction", connectedUsersCounter);
    //////////////////////////
    
    if (user.superSpaceUser.id === userList.id) {
      store.dispatch("UserStore/setIsOnlineAction", false);
      //await store.dispatch("MeetingStore/setMeetinAttendeeAction", null);
      console.log(
        "%cPUSHER EVENT: I DISCONNECTED TO SPACE",
        "background: #222; color: red"
      );
      const roomId = store.getters["MeetingStore/getRoomId"];
      const userLocal = store.getters["UserStore/getSpaceUser"];
      const position = store.getters["UserStore/getPosition"];
      store?.dispatch("UserStore/connectToSpaceAction", {
        id: user.id,
        props: {
          position: this.checkPosition(position) ? position : null,
          availableStatus: userLocal.superSpaceUser.user.availableStatus,
          availableStatusReason:
            userLocal.superSpaceUser.user.availableStatusReason,
          emoji: userLocal.superSpaceUser.user.emoji,
        },
        callback: (response) => {
          // do nothing
        },
        callbackError: (error) => {
          // do nothing
        },
      });
      if (user.superSpaceUser.id === userList.id && roomId) {
        await store?.dispatch("ChatStore/joinRoomChatAction", { roomId });
      }
      if (connectGenetalChat) {
        await store?.dispatch("ChatStore/joinSpaceChatAction", user.space.id);
      }
    }
    await store.dispatch("SpaceStore/setUserOnlineAction", userList);
    if (userDraw) {
      await store.dispatch("SpaceStore/removeUsersInDrawAction", userDraw);
      await store.dispatch("GraphicClientStore/disconnectedUser", userDraw);
    }
  }
  /**
   * USER_PROFILE_EDITED
   * */
  static async userProfileEdited(store?: Store<any>, data?): Promise<void> {
    const { userList, userDraw } = data;
    await store.dispatch("SpaceStore/updateUserInSpace", userList);
    if (userDraw) {
      await store.dispatch("GraphicClientStore/updateUser", userDraw);
    }
  }
  /**
   * USER_AVATAR_CHANGED
   * */
  static async userAvatarChanged(
    store?: Store<any>,
    data?: SpaceUserInterface
  ): Promise<void> {
    await store.dispatch("GraphicClientStore/updateUser", data);
  }
  /**
   * USER_PET_CHANGED
   * */
  static async userPetChanged(
    store?: Store<any>,
    data?: SpaceUserInterface
  ): Promise<void> {
    await store.dispatch("GraphicClientStore/updateUser", data);
  }
  /**
   * USER_STATUS_CHANGED
   * */
  static async userStatusChanged(store?: Store<any>, data?): Promise<void> {
    const { userList, userDraw } = data;
    const userLocal = store.getters["UserStore/getSpaceUser"];
    if (userLocal.superSpaceUser.user.id == userList.user.id) {
      userLocal.superSpaceUser.user.availableStatus =
        userList.user.availableStatus;
      userLocal.superSpaceUser.user.emoji = userDraw.superSpaceUser.user.emoji;
      await store.dispatch("UserStore/setSpaceUserLocal", userLocal);
    }
    await store.dispatch("SpaceStore/updateUserInSpaceList", userList);

    if (userDraw) {
      await store.dispatch("GraphicClientStore/updateUser", userDraw);
      await store.dispatch("SpaceStore/updateUsersInDrawAction", userDraw);
    } else {
      console.log("ERROR userSatatusChange userDraw null");
    }
  }
  /**
   * USER_STATUS_VACATION_ON
   * */
  static async userStatusVacationOn(store?: Store<any>, data?): Promise<void> {
    const { userList, userDraw } = data;
    const userLocal = store.getters["UserStore/getSpaceUser"];
    if (userLocal.superSpaceUser.user.id == userList.user.id) {
      userLocal.superSpaceUser.user.availableStatus =
        userList.user.availableStatus;
      userLocal.superSpaceUser.user.emoji = userDraw.superSpaceUser.user.emoji;
      await store.dispatch("UserStore/setSpaceUserLocal", userLocal);
    }
    if (userDraw) {
      await store.dispatch(
        "SpaceStore/updateUserInSpace",
        userDraw.superSpaceUser.user
      );
      await store.dispatch("GraphicClientStore/vacationOn", userDraw);
    }
  }
  /**
   * USER_STATUS_VACATION_OFF
   * */
  static async userStatusVacationOff(store?: Store<any>, data?): Promise<void> {
    const { userList, userDraw } = data;
    const userLocal = store.getters["UserStore/getSpaceUser"];
    if (userLocal.superSpaceUser.user.id == userList.user.id) {
      userLocal.superSpaceUser.user.availableStatus =
        userList.user.availableStatus;
      userLocal.superSpaceUser.user.emoji = userDraw.superSpaceUser.user.emoji;
      await store.dispatch("UserStore/setSpaceUserLocal", userLocal);
    }
    if (userDraw) {
      await store.dispatch(
        "SpaceStore/updateUserInSpace",
        userDraw.superSpaceUser.user
      );
      await store.dispatch("GraphicClientStore/vacationOff", userDraw);
    }
  }
  /**
   * USER_WORK_IN_OFFICE_CHANGED
   * */
  static async userWorkInOfficeChanged(
    store?: Store<any>,
    data?
  ): Promise<void> {
    const { userList, userDraw } = data;
    if (userDraw) {
      await store.dispatch(
        "SpaceStore/updateUserInSpace",
        userDraw.superSpaceUser.user
      );
      await store.dispatch("GraphicClientStore/updateUser", userDraw);
    }
  }
  /**
   * USER_DISABLED
   * */
  static async userDisabled(
    store?: Store<any>,
    data?,
    router?: VueRouter
  ): Promise<void> {
    const { userList, userDraw } = data;
    const user = store.getters["UserStore/getSpaceUser"];
    if (user.superSpaceUser.user.id === userList.user.id) {
      await store.dispatch("GraphicClientStore/disableUser", userDraw);
      localStorage.setItem("city", "ON");
      router.push("/ban").catch(() => {
        // do nothing
      });
    }
  }
  /**
   * USER_PROFILE_IMAGE_UPDATED
   * */
  static async userProfileImageUpdated(
    store?: Store<any>,
    data?: any
  ): Promise<void> {
    const { userList, userDraw } = data;
    const user = store.getters["UserStore/getSpaceUser"];
    await store.dispatch("SpaceStore/updateImageUserInSpace", userList.user);
    if (user.superSpaceUser.user.id === userList.user.id) {
      await store.dispatch("UserStore/setSpaceUserLocal", userDraw);
    }
  }
  /**
   * USER_DELETED
   * */
  static async userDeleted(store?: Store<any>, data?: any): Promise<void> {
    const { userList, userDraw } = data;
    if (userList) {
      await store.dispatch("ChatStore/removeUnSeenMessageAction", {
        id: userDraw.superSpaceUser.id,
        type: CHAT_TYPE.ONE_TO_ONE,
      });
      await store.dispatch("ChatStore/removeUnSeenMessageAction", {
        id: userDraw.superSpaceUser.id,
        type: CHAT_TYPE.SPACE,
      });
      await store.dispatch("SpaceStore/removeUserInSpace", userList);
    }
  }
  /**
   * Private Event
   * USER_RECEIVING_MEET
   * */
  static async userReceivingMeet(
    store?: Store<any>,
    data?: any,
    stopLoader?: any,
    startLoader?: any,
    onWarning?: any
  ): Promise<void> {
    const space = store.getters["SpaceStore/getSpace"];
    if (data.fromSpaceUser.space.id != space.id) {
      return;
    }
    const localSpaceUser = store.getters["UserStore/getSpaceUser"];
    if (
      localSpaceUser &&
      localSpaceUser.superSpaceUser.user.availableStatus != RED.type
    ) {
      store?.dispatch(
        "MeetingStore/setShowCallFromSpaceUserAction",
        data.fromSpaceUser
      );
      store?.dispatch("MeetingStore/setShowCallModalAction", true);
      await store?.dispatch("MeetingStore/closeMeetingSession");
      const pre_status = {
        availableStatus: localSpaceUser.superSpaceUser.user.availableStatus,
        availableStatusReason:
          localSpaceUser.superSpaceUser.user.availableStatusReason,
        emoji: localSpaceUser.superSpaceUser.user.emoji,
      };
      localStorage.setItem("pre_status", JSON.stringify(pre_status));
      await startLoader(store);
      await store.dispatch("MeetingStore/joinMeetingOneToOneAction", {
        meetingId: data.meeting.MeetingId,
        callback: async (response) => {
          await store.dispatch("UserStore/updateUserStatusAction", {
            userId: localSpaceUser.superSpaceUser.user.id,
            props: {
              availableStatus: RED.type,
              availableStatusReason: null,
              emoji: "U+1F4DE",
            },
            callback: (user) => {
              store.dispatch("SpaceStore/updateUserInSpace", user);
            },
          });
          await store.dispatch(
            "MeetingStore/setMeetingDataAction",
            response.data
          );
          await stopLoader(store);
          await store.dispatch(
            "MeetingStore/setMeetingTypeAction",
            MEETING_TYPE.ONE_TO_ONE
          );
          await store.dispatch(
            "ChatStore/setUserChatAction",
            data.fromSpaceUser
          );
          /*await store.dispatch("SidebarStore/setOpenCall", true);
          await store.dispatch(
            "MeetingStore/setMeetingTypeAction",
            MEETING_TYPE.ONE_TO_ONE
          );
          await store.dispatch(
            "ChatStore/setUserChatAction",
            data.fromSpaceUser
          );
          setTimeout(() => {
            store.dispatch("GraphicClientStore/resizeGraphicClientAction");
          }, 20);
          const preStatus = JSON.parse(localStorage.getItem("pre_status"));
          if (preStatus.availableStatus === GREEN.type) {
            const audio = new Audio(require("@/assets/audio/alert-yellow.mp3"));
            let count = 1;

            const interval = setInterval(() => {
              if (count === 3) {
                audio.pause();
                clearInterval(interval);
              }
              count++;
              audio.play();
            }, 1000);
          }*/
        },
        callbackError: async (error) => {
          await stopLoader(store);
          console.log("Error joinMeetingOneToOneAction ", error);
        },
      });
    } else {
      onWarning(
        i18n.t(""),
        i18n.t("notifications.warningMessages.triedCallYou", {
          name: data.fromSpaceUser.superSpaceUser.user.name,
        }),
        "none"
      );
    }
  }
  static checkPosition(json): boolean {
    try {
      if (
        json["x"] != undefined &&
        json["y"] != undefined &&
        json["z"] != undefined
      ) {
        return true;
      }
    } catch (error) {
      return false;
    }
    return false;
  }
}
